import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { useHistory, Link } from 'react-router-dom'
import { ChevronLeftIcon, CreditCardIcon, CurrencyDollarIcon } from '@heroicons/react/outline'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import { caseCheckoutUrl, caseSuccessUrl, HOME } from '../../routing/paths'
import StoreContext from '../../providers/storesContext'
import ReleaseMethods from '../../components/ReleaseMethods'
import CaseDetailPrice from '../../components/CaseDetailPrice'
import Button from '../../components/Button'
import CaseBill from '../../components/CaseViolations/CaseBill'
import Modal from '../../components/Modal'
import constants, { PAYMENT_METHOD_CREDIT_CARD } from '../../util/constants'

const CaseDetail = () => {
  const history = useHistory()
  const { caseDetailStore } = useContext(StoreContext)
  const [visiblePaymentMethodModal, setVisiblePaymentMethodModal] = useState(false)

  const { immobilizationCase, selectedReleaseMethod, isAssistedRelease, isSelfRelease } =
    caseDetailStore

  const handleCheckout = () => {
    if (
      selectedReleaseMethod === constants.releaseMethodCodes.Assisted &&
      caseDetailStore.selectedPaymentMethod === null &&
      immobilizationCase.hasCashPayment
    ) {
      setVisiblePaymentMethodModal(true)
    } else {
      if (immobilizationCase.isTowed || selectedReleaseMethod !== null) {
        history.push({
          pathname: caseCheckoutUrl(immobilizationCase),
          search: `?release-method=${selectedReleaseMethod}`,
          state: {
            releaseMethod: selectedReleaseMethod,
            paymentMethod: caseDetailStore.selectedPaymentMethod || PAYMENT_METHOD_CREDIT_CARD
          }
        })
      }
    }
  }
  const selectReleaseMethod = (releaseMethod) => caseDetailStore.selectReleaseMethod(releaseMethod)
  const hidePaymentMethodModal = () => {
    setVisiblePaymentMethodModal(false)
  }
  const selectCreditCardMethod = () => {
    caseDetailStore.setCreditCardPaymentMethod()
    setVisiblePaymentMethodModal(false)
    handleCheckout()
  }
  const selectCashMethod = () => {
    caseDetailStore.setCashPaymentMethod()
    setVisiblePaymentMethodModal(false)
    handleCheckout()
  }

  useEffect(() => {
    if (immobilizationCase.isPaid || immobilizationCase.isCash) {
      history.push(caseSuccessUrl(immobilizationCase))
    }

    caseDetailStore.resetPaymentMethod()
    if (!caseDetailStore.billsLoaded) {
      caseDetailStore.loadCaseBills()
    }

    topBarStore.setTitle(`Case # ${immobilizationCase.id}`)
    topBarStore.setActionIcon(
      <button onClick={()=> history.goBack()}>
        <ChevronLeftIcon className="h-6 w-6" />
      </button>
    )

  }, [caseDetailStore.billsLoaded])

  return (
    <div className="flex flex-col flex-1">
      <CaseBill />
      {!immobilizationCase.isTowed && (
        <ReleaseMethods
          selectReleaseMethod={selectReleaseMethod}
          isAssistedRelease={isAssistedRelease}
          isSelfRelease={isSelfRelease}
        />
      )}
      <div className="my-4">
        <CaseDetailPrice total={immobilizationCase?.bill?.total} />
      </div>
      <div className="mb-8">
        <Button
          disabled={!immobilizationCase.isTowed && !selectedReleaseMethod}
          extraStyle="w-full transition-all"
          onClick={handleCheckout}
        >
          Check out
        </Button>
      </div>
      <Modal open={visiblePaymentMethodModal} noButtons onCancel={hidePaymentMethodModal} small>
        <div className="flex-1">
          <div className="font-bold text-center text-lg px-8">Payment Method</div>
          <div className="mt-4">
            <div
              className="flex items-center font-bold bg-gray-50 p-2 mb-2 cursor-pointer hover:bg-gray-100 rounded-md"
              onClick={selectCreditCardMethod}
            >
              <CreditCardIcon className="w-6 h-6 mr-2" /> Credit card
            </div>
            <div
              className="flex items-center font-bold bg-gray-50 p-2 cursor-pointer hover:bg-gray-100 rounded-md"
              onClick={selectCashMethod}
            >
              <CurrencyDollarIcon className="w-6 h-6 mr-2" /> Cash
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default observer(CaseDetail)
